import { Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ToastService } from '@app/portal/services/toast-service';
import { fadeInOut, SlideInOut } from '@app/utils/angular-animations';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'portal-toasts',
  templateUrl: './toasts.component.html',
  host: {
    class: 'portal-toasts',
  },
  standalone: false,
  animations: [fadeInOut(200), SlideInOut],
})
export class ToastsComponent {
  toasts = toSignal(this.toastService.toasts$);

  constructor(private toastService: ToastService) {}
}
